"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = installDebugger;

var _debugParameters = require("./webgl-debug/debug-parameters");

// Expose Khronos Debug support module on global context

/* global window, global */
var WebGLDebug = require('webgl-debug');

var global_ = typeof global !== 'undefined' ? global : window;
global_.WebGLDebug = WebGLDebug;
console.log('luma.gl: WebGL debug support imported'); // eslint-disable-line
// eslint-disable-next-line

function installDebugger() {
  (0, _debugParameters.installParameterDefinitions)();
  console.log('luma.gl: WebGL debug support installed'); // eslint-disable-line
}
//# sourceMappingURL=debug.js.map


//////////////////
// WEBPACK FOOTER
// ./~/luma.gl/dist/es5/debug.js
// module id = 1553
// module chunks = 0